<template>
  <div id="InstanceContainer">
    <div v-show="showBase">
      <InstanceBase ref="instanceBase" :baseType="baseType" :formId="formId"></InstanceBase>
    </div>
    <div v-show="showSliceProfile">
      <InstanceSliceProfile ref="instanceSliceProfile"></InstanceSliceProfile>
    </div>
    <div v-show="showNeConfig">
      <InstanceNeConfig ref="instanceNeConfig"></InstanceNeConfig>
    </div>
  </div>
</template>
<script>
import InstanceBase from "./InstanceBase";
import InstanceSliceProfile from "./InstanceSliceProfile";
import InstanceNeConfig from "./InstanceNeConfig";
import { EventBus } from "../../../plugins/eventBus";

export default {
  name: "InstanceServiceProfile",
  props: {
    index: Number
  },
  components: {
    InstanceBase,
    InstanceSliceProfile,
    InstanceNeConfig
  },
  data() {
    return {
      baseType: 0,
      formId: "instanceBaseForm",
      showBase: true,
      showSliceProfile: false,
      showNeConfig: false,
      base_v_status: false,
      idSliceProfile: 0,
      newRunModeRadioValue: "0",
    };
  },
  methods: {
    init(checkedData) {
      this.$refs.instanceBase.init(checkedData);
      this.$refs.instanceSliceProfile.getSliceProfileList(checkedData.id);
    },
    initNssi(checkedData,runModeRadioValue) {
      if(checkedData.id!=this.idSliceProfile||runModeRadioValue!=this.newRunModeRadioValue){//若子网模板改动或者运行模式改变则初始化最后一页
      this.$refs.instanceNeConfig.clear();
      this.$refs.instanceNeConfig.initNeConfig(checkedData,runModeRadioValue,(res) =>{
        if(res){
         this.$refs.instanceNeConfig.neTypeChangeFunc(0);//0为第一次加载
         this.idSliceProfile=checkedData.id;
         this.newRunModeRadioValue=runModeRadioValue;
        }
      });}
    },
    getInstanceInfo(callback) {
      const serviceProfile = this.$refs.instanceBase.getInstanceBase(); //网络切片基础信息
      this.$refs.instanceNeConfig.getFormData(res=> {
      if (!res) {
        callback(false) ;
      }     
      else{
      let sliceProfile = res;
      const jsonStr = { serviceProfile, sliceProfile };
      callback(jsonStr) ;
      }
      
      }); //子网和网元配置


    },
    validation(callback) {
      this.base_v_status = this.$refs.instanceBase.validate();
      if(this.base_v_status){
      return   this.checkRepeat(callback);
      }
      else{
        return false;
      }
    },
    validationSliceProfile() {
      let checkedSliceProfileData = this.$refs.instanceSliceProfile.getCheckedData(false);
      return checkedSliceProfileData;
    },
     checkRepeat(callback){
      const serviceProfile = this.$refs.instanceBase.getInstanceBase(); //网络切片基础信息
       this.$axios.post(`/lte/ems/networkSlice/checkNetworkSlice`, 
       {name: serviceProfile.name,snssaiList:serviceProfile.sNSSAIList}).then(response => {
        if (response &&response.status === 200 &&response.data.errorCode === "SUCCESS" ){
            callback(true);
        }
        else{
            EventBus.$emit("toast", {type: "warning", content: response.data.errorString });
            callback(false);

        }
      });
    }
  },
  watch: {
    index() {
      if (this.index === 0) {
        this.showBase = true;
        this.showSliceProfile = false;
        this.showNeConfig = false;
      } else if (this.index === 1) {
        this.showBase = false;
        this.showSliceProfile = true;
        this.showNeConfig = false;
      } else if (this.index === 2) {
        this.showBase = false;
        this.showSliceProfile = false;
        this.showNeConfig = true;
      }
    }
  }
};
</script>
